import { Avatar, Stack, Typography } from "@mui/material";

interface NameProps {
  firstName?: string;
  lastName?: string;
  onSave: (name: { firstName: string; lastName: string }) => void;
}

export default function Name(props: NameProps) {
  if (!props.firstName || !props.lastName) {
    return null;
  }
  return (
    <Stack direction="row" spacing={2}>
      <Avatar data-testid="user-avatar">
        {props.firstName.charAt(0)}
        {props.lastName.charAt(0)}
      </Avatar>
      <Typography variant="h4" data-testid="user-full-name">
        {props.firstName} {props.lastName}
      </Typography>
    </Stack>
  );
}
